/*----- Core -----*/
import React      from 'react'
import styled 		from 'styled-components'
import PropTypes 	from 'prop-types'

/*----- Assets -----*/
import phoneIcon 			 from '../assets/icons/phone.svg'
import fbIcon    			 from '../assets/icons/social_network/facebook.svg'
import igIcon    			 from '../assets/icons/social_network/instagram.svg'
import webIcon    		 from '../assets/icons/social_network/web.svg'
import fingerprintIcon from '../assets/icons/fingerprint.svg'
import emailIcon       from '../assets/icons/email.svg'
import Title 					 from './text/Title'

/*----- Components -----*/
import Paragraph  from '../components/text/Paragraph'

/*----- Commons -----*/
import Montserrat from '../commons/mixins/fonts/Montserrat'
import Color      from '../commons/Color'

/*----- Styles -----*/
const StyledPerson = styled.article`
	width: 100%;
	display: flex;
	flex-direction: column;
	padding: 64px 32px;

	.person__pic {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-bottom: 32px;
		.person__image-container {
			display: flex;
			justify-content: center;
			align-items: center;
			img {
				width: 200px;
				border-radius: 50%;
			}
		}
		.custom-paragraph {
			text-align: center;
			line-height: 20px;
			margin: 16px 0 !important;
		}
	}
	.person__data {
		.person__contact-icon {
			margin-right: 16px;
		}
		.custom-paragraph {
			margin: 0 !important;
		}
		.custom-title {
			margin: 0;
		}
		.person__name {
			margin-bottom: 16px;
		}
		.person__call-to-action {
			${ Montserrat(10, 600, Color.main) };
			border: 1px solid ${ Color.main };
			padding: 4px 16px 4px 12px;
			margin-right: 16px;
			border-radius: 30px;
		}
	}
	.data-item {
		display: flex;
		align-items: center;
		margin-bottom: 16px;
		overflow: auto;
		a {
			display: inline-flex;
    	align-items: center;
		}
		img {
			width: 20px;
		}
	}
	.person__social-networks {

	}
	.person__social-item {
		margin-right: 16px;
		margin-bottom: 8px;
    display: inline-block;
		color: black;
		img { 
			width: 20px;
			margin-right: 8px;
		}
	}
`

const Person = ({ fullname, imageUrl, phone, communication_channels, snn }) => (
	<StyledPerson className="person">
		<div className="person__pic">
		{
			imageUrl? (
			<div className="person__image-container">
				<img src={ imageUrl } alt="person profile"/>
			</div>
			) : null
		}


		</div>
		<div className="person__data">
			<div className="person__name">
				<Title content={fullname} size={4} />
			</div>
			<div className="data-item">
				<img src={ fingerprintIcon } alt="fingerprintIcon icon" className="person__contact-icon"/>
				<div>
					<Title size={6} content="Matrícula"/>
					<Paragraph content={snn} />
				</div>
			</div>
			<div className="data-item">
				<a href={`tel:+549${phone}`} className="person__call-to-action">
					<img src={ phoneIcon } alt="phone icon" className="person__contact-icon"/>
					Llamar
				</a>
				<div>
					<Title size={6} content="Teléfono"/>
					<Paragraph content={phone} />
				</div>
			</div>
			<div className="data-item">
				<a href={`mailto:${communication_channels.email}`} rel="noopener noreferrer" target="_blank" className="person__call-to-action">
					<img src={ emailIcon } alt="email icon" className="person__contact-icon"/>
					Escribir
				</a>
				<div>
					<Title size={6} content="Email"/>
					<Paragraph content={ communication_channels.email } />
				</div>
			</div>
		</div>
		<div className="person__social-networks">
			{
				communication_channels.facebook || communication_channels.instagram ? 
				<Title content="Encontrame en: " size={6}/> 
				: null
			}
			
			{
				communication_channels.facebook? (
					<a href={`https://www.facebook.com/${communication_channels.facebook}`} rel="noopener noreferrer" target="_blank" className="person__social-item">
						<img src={ fbIcon } alt="social network icon"/>
						{communication_channels.facebook}
					</a>
				) : null
			}
			{
				communication_channels.instagram? (
					<a href={`http://instagram.com/${communication_channels.instagram}`} rel="noopener noreferrer" target="_blank" className="person__social-item">
						<img src={ igIcon } alt="social network icon"/>
						{ communication_channels.instagram }
					</a>
				) : null
			}
			{
				communication_channels.web? (
					<a href={communication_channels.web} rel="noopener noreferrer" target="_blank" className="person__social-item">
						<img src={ webIcon } alt="web icon"/>
						{ communication_channels.web }
					</a>
				) : null
			}
		</div>
	</StyledPerson>
)
export default Person

/*----- PropTypes -----*/
Person.propTypes = {
	fullname:     PropTypes.string.isRequired,
	snn:          PropTypes.number,
	phone:        PropTypes.string
}
